import { Toaster } from 'react-hot-toast';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Home } from '@/pages/Home';
import { PlayerRankings } from '@/pages/PlayerRankings';
import TradeCalculatorWithRoster from '@/pages/TradeCalculatorWithRoster';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import DraftAssistant from '@/pages/DraftAssistant';
import MyRoster from '@/pages/MyRoster';
import Settings from '@/pages/Settings';
import TestWeeklyBreakdown from '@/pages/TestWeeklyBreakdown';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-ink text-zinc-100">
      <ScrollToTop />
      <Navbar />
      <Toaster position="top-center" />
      
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/players" element={<PlayerRankings />} />
          <Route path="/trade-calculator" element={<TradeCalculatorWithRoster />} />
          <Route path="/draft-assistant" element={<DraftAssistant />} />
          <Route path="/my-roster" element={<MyRoster />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/test-weekly-breakdown" element={<TestWeeklyBreakdown />} />
        </Routes>
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
